import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=4190408c&scoped=true&"
import script from "./TabNav.vue?vue&type=script&lang=js&"
export * from "./TabNav.vue?vue&type=script&lang=js&"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=4190408c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4190408c",
  null
  
)

export default component.exports